@import 'apps/webcomponents/src/assets/text-helpers.scss';

:host {
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  flex-direction: column;
}

.search-query-panel {
  flex: 1;
  height: auto;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer));
}

.company-selector {
  width: auto;
}
